/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Vector1 from "@img/Trainer/Vector1.png";
import Vector2 from "@img/Trainer/Vector2.png";
import Vector3 from "@img/Trainer/Vector3.png";
import Vector4 from "@img/Trainer/Vector4.png";
import Vector5 from "@img/Trainer/Vector5.png";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Trainer = () => {
  const [trainer, setTrainer] = useState([]);

  useEffect(() => {
    fetchTrainer();
  }, []);

  const fetchTrainer = async () => {
    try {
      const response = await fetch("https://cms.okoce.net/api/admin/trainers");
      if (!response.ok) {
        throw new Error("Gagal mengambil data trainer");
      }
      const data = await response.json();
      setTrainer(data.data[0] || []);
    } catch (error) {
      setTrainer([]);
    }
  };

  const vectorImages = [Vector1, Vector2, Vector3, Vector4, Vector5];

  return (
    <>
      <div className="flex overflow-hidden relative flex-col items-start px-12 py-20 text-white shadow-sm min-h-[825px] max-md:px-5">
        <img
          loading="lazy"
          src={`${process.env.REACT_APP_API_URL}/${trainer.image}`}
          className="object-cover absolute inset-0 size-full"
          alt={`Header ${trainer.image}`}
        />
        <div className="relative text-4xl font-bold leading-10 max-md:mt-10 max-md:max-w-full mobile:mt-64 lg:mt-96">
          {trainer.title}
        </div>
        <div
          className="relative text-lg leading-7 text-justify w-[616px] max-md:max-w-full mobile:mt-0 lg:mt-6"
          dangerouslySetInnerHTML={{ __html: trainer.description }}
        />
      </div>

      {trainer?.cta && (
        <div className="flex flex-col px-16 py-20 ml-10 mr-10 text-black max-md:px-5">
          <div className="mt-6 text-4xl font-bold leading-10 max-md:text-3xl">
            {trainer.cta[0]?.cta_title}
          </div>
          <div className="mt-7 text-lg leading-7 text-justify max-md:text-base" dangerouslySetInnerHTML={{ __html: trainer.cta[0]?.cta_description }}
          />
        </div>
      )}

      <div className="flex flex-col px-16 py-20 bg-[#1c75ac] max-md:px-5">
        <div className="mt-8 max-md:max-w-full">
          <h1 className="mt-5 text-4xl font-bold leading-10 text-white">
            Siapapun bisa menjadi trainer di OK OCE INDONESIA!
          </h1>
          <h3 className="mt-4 text-xl font-medium leading-10 text-white">
            Lengkapi syarat dibawah ini agar kamu bisa menjadi Trainer di OK OCE
            INDONESIA!
          </h3>
        </div>
        <div className="mt-24 max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-0">
            {trainer?.terms?.map(
              ({ terms_title, terms_description }) => (
                <div className="flex flex-col flex-1 max-md:ml-0">
                  <div className="flex flex-col text-white rounded-xl bg-[#1c75ac] border-white border-2 p-4 max-md:mt-10 min-h-[250px]">
                    <div className="text-2xl font-bold leading-8 mb-4">
                      {terms_title}
                    </div>
                    <div
                      className="text-lg leading-7 text-justify flex-grow"
                      dangerouslySetInnerHTML={{ __html: terms_description }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
        {/* <div className="justify-center items-center self-center px-16 py-4 mt-36 max-w-full text-xl font-semibold leading-6 text-center text-white bg-[#e01f31] rounded-[50px] w-[441px] max-md:px-5 max-md:mt-10">
          MULAI BEKERJASAMA
        </div> */}
      </div>

      <div className="flex flex-col justify-center py-14 bg-white">
        <div className="flex justify-center items-center px-16 py-10 w-full bg-white max-md:px-5 max-md:max-w-full">
          <div className="flex flex-col w-full max-w-[1217px] max-md:max-w-full">
            <div className="text-5xl font-bold text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
              Benefit Menjadi Trainer
            </div>
            <div className="mt-8 text-lg leading-4 text-neutral-700 max-md:max-w-full">
              Menjadi trainer memberikan kesempatan untuk berbagi pengetahuan,
              memperluas jaringan profesional, dan merasa puas melihat
              perkembangan peserta.
            </div>
            <div className="mt-12 max-md:mt-10 max-md:max-w-full">
              <div className="flex flex-wrap gap-5 max-md:flex-col max-md:gap-0">
                {trainer?.benefit?.map(
                  ({ benefit_title, benefit_description }, index) => (
                    <div
                      key={index}
                      className="flex flex-col w-[32%] max-md:w-full"
                      style={{ marginBottom: "20px" }}
                    >
                      <div className="flex flex-col grow px-8 pt-5 pb-16 w-full text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-md max-md:px-5 max-md:mt-6">
                        <img
                          src={vectorImages[index % vectorImages.length]}
                          className="aspect-square w-[50px]"
                          alt={`Vector ${(index % vectorImages.length) + 1}`}
                        />
                        <div className="mt-4 text-2xl font-bold leading-9">
                          {benefit_title}
                        </div>
                        <div
                          className="mt-4 text-base leading-6 text-justify"
                          dangerouslySetInnerHTML={{
                            __html: benefit_description,
                          }}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingMenu />
    </>
  );
};

export default Trainer;
